import { render } from "./CreateView.vue?vue&type=template&id=dcb5aa4c&scoped=true"
import script from "./CreateView.vue?vue&type=script&lang=js"
export * from "./CreateView.vue?vue&type=script&lang=js"

import "./CreateView.vue?vue&type=style&index=0&id=dcb5aa4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcb5aa4c"]])

export default __exports__